import React, { CSSProperties, useMemo } from "react";
import "./styles.scss";
import TestsID from "../../utils/TestsID";
import KC_Colors from "../../designsystem/KC_Colors";
import KC_Span from "../../designsystem/KC_Span/KC_Span";
import KC_Heading1 from "../../designsystem/typography/KC-Heading/KC_Heading1";
import { useUrlQuery } from "../../utils/hooks/useUrlQuery";
import { SaasFlyersOrderI } from "../../model/saasFlyersOrderI";

const SaasFlyersOrder = (props: SaasFlyersOrderI) => {
  const Component = props.Component;
  const query = useUrlQuery();

  const payment_intent_id = React.useMemo(() => {
    return query.get("payment_intent");
  }, [query]);

  const style = useMemo<CSSProperties>(() => {
    return {
      visibility: !!payment_intent_id ? "hidden" : "visible"
    };
  }, [payment_intent_id]);

  return (
    <div
      id={TestsID.SAAS_FLYERS_ORDER_PAGE_CONTAINER}
      className="p-4 st-gap saas-flyers-order__container dashboard-v2 h-auto"
    >
      <div className="d-flex flex-column justify-content-center bg-white p-4 saas-flyers-order__left-container">
        <KC_Heading1
          text={props.subheading || ""}
          primary={true}
          style={style}
        />
        <KC_Span
          text={props.description || ""}
          color={KC_Colors.Grey}
          style={style}
        />
        <div className="saas-flyers-order__content-wrapper">
          {Component ? <Component /> : null}
        </div>
      </div>
    </div>
  );
};

export default SaasFlyersOrder;
